import React from "react";
import { LightBulbIcon, RocketLaunchIcon } from "@heroicons/react/24/outline";
import "./AboutMissionVision.css";

const AboutMissionVision = () => (
  <section id="about-us" className="about-mission" aria-labelledby="about-mission-title">
    <div className="about-mission__heading">
      <p className="about-mission__eyebrow">What guides us</p>
      <h2 id="about-mission-title">Mission &amp; Vision</h2>
    </div>

    <div className="about-mission__cards">
      <article className="about-mission__card about-mission__card--vision">
        <span className="about-mission__icon"><LightBulbIcon /></span>
        <h3>Our Vision</h3>
        <p>
          Our vision is to become the biggest contributor to building a better,
          healthier world through precision, integrity and innovation.
        </p>
      </article>
      <article className="about-mission__card about-mission__card--mission">
        <span className="about-mission__icon"><RocketLaunchIcon /></span>
        <h3>Our Mission</h3>
        <p>
          We invest in companies and capabilities that take responsibility for
          making the world a healthier place to live and work.
        </p>
      </article>
    </div>
  </section>
);

export default AboutMissionVision;
